import { ReportMemberService } from './report-member-service';

export default ReportMemberService;
